module.exports = __webpack_public_path__ + "img/76f20b0.jpg";